import { render } from "./simpleTextBox.vue?vue&type=template&id=6c14cd3a&scoped=true"
import script from "./simpleTextBox.vue?vue&type=script&lang=js"
export * from "./simpleTextBox.vue?vue&type=script&lang=js"

import "./simpleTextBox.vue?vue&type=style&index=0&id=6c14cd3a&scoped=true&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c14cd3a"]])

export default __exports__